import React, { useState } from "react";
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    TextField,
} from "@material-ui/core";

import ToggleAllCheckbox from "../renderer/help/ToggleAllCheckbox.jsx";

export const listObjectsRenderer = (
    values,
    name,
    fieldUpdateHandler,
    mutable,
    defaultValues,
    isError,
) => {
    const arrayTypes = ["room_types", "rates", "hotels"];
    const [showHidden, setHidden] = useState(false);

    const classToggleRoomTypesInput = arrayTypes.includes(name)
        ? "classToggleRoomTypesInput"
        : "";
    const toggle = arrayTypes.includes(name);

    const toggleHidden = (e) => {
        e.preventDefault();
        setHidden(!showHidden);
    };

    let idxList = [];
    let renderValuesEl = [];

    if (values && values?.length > 0) {
        idxList = values.some((elem) => typeof elem === "object")
            ? values.map((value) => value.id)
            : values;
    }

    const filteredDefVal = defaultValues
        ? defaultValues.filter((roomType) => roomType.active)
        : [];

    const defVal = showHidden
        ? filteredDefVal.filter((rate) => !rate.hidden)
        : filteredDefVal;

    defVal.sort(function (a, b) {
        if (a.order > b.order) {
            return 1;
        }
        if (a.order < b.order) {
            return -1;
        }

        return 0;
    });

    renderValuesEl =
        defVal?.length > 0 &&
        defVal.map((value) => (
            <FormControlLabel
                disabled={mutable ? false : true}
                key={value.id}
                checked={idxList.includes(value.id)}
                control={
                    <Checkbox
                        name={value.id.toString()}
                        color="primary"
                        onChange={(e) =>
                            handleChange(
                                name,
                                e.target.name,
                                fieldUpdateHandler,
                                values,
                                defVal,
                            )
                        }
                    />
                }
                label={value.name}
            />
        ));

    let elementsToRender = renderValuesEl ? (
        <>
            <FormGroup key={defVal?.length || 0} className={classToggleRoomTypesInput + name} row>
                {renderValuesEl}
                {toggle && (
                    <ToggleAllCheckbox
                        values={values}
                        name={name}
                        fieldUpdateHandler={fieldUpdateHandler}
                        defVal={defVal}
                    />
                )}
                {name == "rates" && (
                    <button
                        style={{
                            backgroundColor: "#dd8d1b",
                            color: "white",
                            padding: "8px 16px",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            marginLeft: "20px",
                        }}
                        onClick={toggleHidden}
                    >
                        {!showHidden
                            ? "Убрать скрытые тарифы"
                            : "Показать скрытые тарифы"}
                    </button>
                )}
            </FormGroup>
            {isError && <TextField error={!!isError} helperText={isError} />}
        </>
    ) : (
        <Typography>Нет доступных полей</Typography>
    );

    return elementsToRender;
};

// Helper funcs

/**
 * Updates payment methods connected to rate
 *
 * @param {string} fieldName
 * @param {string} pickedIdString
 * @param {function} fieldUpdater
 * @param {Object[]} values
 * @param {Object[]} hotelDefaultValues
 */

const handleChange = (
    fieldName,
    pickedIdString,
    fieldUpdater,
    values,
    hotelDefaultValues,
) => {
    const pickedId = parseInt(pickedIdString);
    let paymentMethodsToChange = !values || values.length === 0 ? [] : values;
    const existingIdxSet =
        paymentMethodsToChange.length === 0
            ? new Set()
            : new Set(paymentMethodsToChange.map((method) => method.id));

    for (const hotelValue of hotelDefaultValues) {
        if (!existingIdxSet.has(pickedId)) {
            if (hotelValue.id === pickedId) {
                paymentMethodsToChange.push(hotelValue);
            }
        } else if (existingIdxSet.has(pickedId)) {
            paymentMethodsToChange = paymentMethodsToChange.filter(
                (method) => method.id !== pickedId,
            );
        }
    }

    fieldUpdater(fieldName, paymentMethodsToChange);
};
